<script setup lang="ts">
import { computed } from 'vue';
import { Gift, Check } from 'lucide-vue-next';

import useContext from '@/composables/useContext';
import useWebsiteTexts from '@/composables/useWebsiteTexts';

const { cart, channel } = useContext();
const { websiteText } = useWebsiteTexts();

const cartRow = computed<any>(() => cart.value?.rows?.[0]);
const hasGiftInCart = computed(() => !!cartRow.value);

const cartRowProductName = computed(
  () => cartRow.value?.variantName || cartRow.value?.baseProductName || '',
);

const checkoutUrl = computed(() => channel.value?.checkoutUrl || '');
</script>

<template>
  <router-link
    v-if="hasGiftInCart && checkoutUrl"
    :to="checkoutUrl"
    :title="cartRowProductName"
    class="relative inline-flex items-center text-foreground transition-colors hover:opacity-70"
    :aria-label="cartRowProductName"
  >
    <span class="relative inline-flex animate-gift-bounce">
      <Gift class="h-5 w-5" />
      <span class="absolute -bottom-1 -right-1 inline-flex h-[14px] w-[14px] items-center justify-center rounded-full bg-background">
        <Check class="h-[10px] w-[10px] text-success" :stroke-width="3" />
      </span>
    </span>
  </router-link>

  <div
    v-else
    class="relative inline-flex cursor-default items-center text-foreground"
    :aria-label="websiteText('getmygift__header__nogiftcardselected').value"
  >
    <Gift class="h-5 w-5" />
  </div>
</template>
